export default {
    RefundOnlyToBeReviewed: {
        OrderNo: '退款单号/销售单号',
        Document: '退款单来源',
        Refundtype: '退款单类型',
        Nickname: '买家昵称',
        Refund: '退款时间',
        Approved: '审核通过',
        Approval: '审核拒绝',
        form: {
            Third: '三方退款单号',
            Refund: '内部退款单号',
            party: '客户订单号',
            PlatformOrder: '平台订单号',
            Order: '内部订单号',
            timeout: '预占超时',
            exception: '推送异常',
            loss: '数据异常',
            Stock: '缺货订单',
            Preemption: '预占',
            ReturnMessage: '返回消息',
            Refundtype: '退款单类型',
            Type: '退款类型',
            Source: '退款单来源',
            status: '订单状态',
            Approval: '审核状态',
            quantity: '退款数量',
            Total: '合计退款金额',
            reason: '退款原因',
            comments: '买家备注',
            service: '客服备注',
            nickname: '买家昵称',
            store: '销售店铺',
            channel: '销售渠道',
            Three: '三方退款时间',
            creation: '内部创单时间',
            Completion: '完成时间',
        },
    }
};
